// This component checks to see if the visitor has an email address set
// If not there is a form for entering their email address
// Once the email is entered it will redirect them to the Facebook Login (`/login`)
import React, { Component } from 'react'
import Form from './form'
import Wrapper from './wrapper'
import PropTypes from 'prop-types'

class Home extends Component {
	state = {
		displayModal: true,
		modalEmail: ''
	}

	constructor(props) {
		super(props)
		this.handleFacebookAuthed = this.handleFacebookAuthed.bind(this)
	}
	componentDidMount() {
		if(window.mixpanel) {
			window.mixpanel.track('Landing Page Viewed', {
				name: 'AdScore'
			})
		}
	}

	handleFacebookAuthed(session, email) {
		this.props.facebookSessionSet(session, email)
		this.props.history.push('/accounts')
	}

	render() {
		return (
			<Wrapper>
				<Form
					history={this.props.history}
					facebookSessionSet={this.handleFacebookAuthed}
					trafficSource={this.props.trafficSource}
					paidTrafficSource={this.props.paidTrafficSource} />
			</Wrapper>
		)
	}
}

Home.propTypes = {
	trafficSource: PropTypes.string,
	paidTrafficSource: PropTypes.string,
	sessionEmail: PropTypes.string,
	history: PropTypes.object,
	facebookSessionSet: PropTypes.func
}

export default Home


// WEBPACK FOOTER //
// ./src/containers/Home/index.js